"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var DEFAULT_PROPS = {
  links: [{
    ctaType: 'button',
    label: 'Confirm & Change',
    priority: 'critical',
    url: '/buy/configure'
  }],
  overlayCopy: {
    text: 'Changing your current car will lose any configuration options you have currently made. Are you sure you want to change vehicles?',
    title: 'Change your car'
  }
};
var _default = DEFAULT_PROPS;
exports["default"] = _default;